import $ from 'jquery';

export default class AuthenticationService {
    static logIn(email, password, rememberMe, isAdminOnly) {
        return $.ajax({
            url: '/rest/authentication/log-in',
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify({
                email: email,
                password: password,
                rememberMe: rememberMe,
                isAdminOnly: isAdminOnly
            })
        });
    }

    static resetPassword(newPassword) {
        return $.ajax({
            url: '/rest/authentication/reset-password',
            type: 'post',
            data: newPassword
        });
    }

    static requestPasswordReset(email) {
        return $.ajax({
            url: '/rest/authentication/request-password-reset',
            type: 'post',
            data: email
        });
    }

    static register(firstName, lastName, companyName, role, telephone, email, linkedInProfileUrl) {
        return $.ajax({
            url: '/rest/authentication/register',
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify({
                firstName: firstName,
                lastName: lastName,
                companyName: companyName,
                role: role,
                telephone: telephone,
                email: email,
                linkedInProfileUrl: linkedInProfileUrl
            })
        });
    }
}


// WEBPACK FOOTER //
// ./src/auth/authentication-service.js